<template>
  <a-row :gutter="16">
    <a-col :xxl="4" :xl="6" :lg="8" :md="12">
      <a-range-picker v-model:value="queryForm.daterange" :ranges="ranges" :locale="locale" value-format="YYYY-MM-DD"
        style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.orgid" :options="qorgs" :filter-option="$filters.filterOption" show-search
        style="width:100%;">
      </a-select>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-button type="primary" @click="refresh">查询</a-button>
    </a-col>
  </a-row>
  <div class="d-flex justify-space-between align-center mb-2 mt-2">
    <a-space>
      <a-button type="link" @click="refresh">刷新数据</a-button>
    </a-space>
    <!-- <a-space>
      <a-dropdown>
        <template #overlay>
          <a-menu>
            <a-menu-item @click="exportselected" :disabled="selectedRowKeys.length === 0">导出勾选</a-menu-item>
            <a-menu-item @click="exportall">导出所有页</a-menu-item>
          </a-menu>
        </template>
<a-button type="primary">
  导出数据
  <DownOutlined />
</a-button>
</a-dropdown>
</a-space> -->
  </div>
  <div class="static">
    <a-row>
      <a-col :span="8">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">总库存数</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="总库存数" :value="total_count" style="margin-right: 50px" />
      </a-col>
      <a-col :span="8">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">总SKU数</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="总SKU数" :value="total_sku_count" />
      </a-col>
      <a-col :span="8">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">总货值(¥)</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="总货值(¥)" :precision="2" :value="total_amount" />
      </a-col>
    </a-row>
  </div>
  <a-table :columns="columns" bordered :data-source="data" :loading="dataLoading" :scroll="{ x: width, y: 600 }"
    :pagination="{
      current: page,
      pageSize: limit,
      total: count,
      showQuickJumper: true,
      showSizeChanger: true,
    }" @change="(pagination) => {
      page = pagination.current;
      limit = pagination.pageSize;
    }" row-key="_id" :row-selection="{
      selectedRowKeys,
      onChange: (keys) => selectedRowKeys = keys
    }">
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'org'">
        {{ getorgname(record.orgid) }}
      </template>
      <template v-if="column.dataIndex === 'state'">
        <p v-if="record.receive_time">已到货</p>
        <p v-else-if="record.pay_time">已付款</p>
      </template>
    </template>
  </a-table>
</template>
<script setup>
import dayjs from 'dayjs';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { DownOutlined, LoadingOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { ref, watch, computed, onMounted, getCurrentInstance, } from "vue";
import _ from "underscore";
const columns = [
  { title: '商户名称', dataIndex: 'org', width: 100, },
  { title: '商品名称', dataIndex: 'name', width: 150 },
  { title: 'SKU', dataIndex: 'SKU', width: 150, },
  { title: '库存数量', dataIndex: 'quantity', width: 100, },
  { title: '单价', dataIndex: 'price', width: 100, },
  { title: '计量单位', dataIndex: 'unit', width: 100, },
  { title: '仓库', dataIndex: 'warehouse', width: 150, },
  { title: '状态', dataIndex: 'state', width: 100, },
  { title: '创建时间', dataIndex: 'create_time', width: 150, }
];
const ranges = ref({
  '近一周': [dayjs().subtract(7, 'day'), dayjs()],
  '近一月': [dayjs().subtract(1, 'month'), dayjs()],
  '近三月': [dayjs().subtract(3, 'month'), dayjs()],
  '近六月': [dayjs().subtract(6, 'month'), dayjs()],
});
const { proxy } = getCurrentInstance();

const queryForm = ref({
  daterange: [
    proxy.$utils.moment().subtract(1, 'month').format('YYYY-MM-DD'),
    proxy.$utils.moment().format('YYYY-MM-DD'),
  ],
  orgid: "ALL",
});
const dataLoading = ref(false);
const loading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const total_count = ref(0);
const total_sku_count = ref(0);
const total_amount = ref(0);
const selectedRowKeys = ref([]);
const orgs = ref([]);

const sorgs = computed(() => orgs.value.map(n => ({ value: n._id, label: n.name })));
const qorgs = computed(() => {
  return [
    { value: 'ALL', label: '全部商户' },
    ...sorgs.value,
  ]
});
const width = computed(() => proxy.$utils.twidth(columns));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

onMounted(() => {
  refresh();
});
const refresh = () => {
  getData();
  getStatistics();
}
const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/inventory/list", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm:ss'),
        };
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
      orgs.value = res.data.orgs;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const getStatistics = () => {
  loading.value = true;
  proxy.$api.doAPI("/inventory/statistics", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    loading.value = false;
    if (res.code === 0) {
      total_count.value = res.data.total_count;
      total_sku_count.value = res.data.total_sku_count;
      total_amount.value = res.data.total_amount;
    } else {
      message.error(res.msg);
      loading.value = false;
    }
  }).catch((err) => {
    console.error(err);
  });
};
const exportselected = () => {
}
const exportall = () => {
}
const getorgname = (orgid) => {
  return _.findWhere(orgs.value, { _id: orgid })?.name;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}

.static {
  padding: 20px;
  background-color: #f2f2f2;
  margin-bottom: 10px;
}
</style>